
import { ApiGroup } from "../types/ApiTypes"

/**
 * 포인트 한도 정책 관련 API
 */
const PointLimitPolicyAPI: ApiGroup = {
    pagedList: {
        title: "포인트 한도 정책 목록 조회",
        url: "/PointLimitPolicy/PagedList",
        method: "POST",
        paramz: {},
    },
    list: {
        title: "포인트 한도 정책 전체 조회",
        url: "/PointLimitPolicy/List",
        method: "GET",
        paramz: {},
    },
    getById: {
        title: "포인트 한도 정책 상세 조회",
        url: "/PointLimitPolicy/:id",
        method: "GET",
        paramz: {},
        pathParams: ["id"],
    },
    create: {
        title: "포인트 한도 정책 생성",
        url: "/PointLimitPolicy",
        method: "POST",
        paramz: {},
    },
    update: {
        title: "포인트 한도 정책 수정",
        url: "/PointLimitPolicy/:id",
        method: "PUT",
        paramz: {},
        pathParams: ["id"],
    },
    delete: {
        title: "포인트 한도 정책 삭제",
        url: "/PointLimitPolicy/:id",
        method: "DELETE",
        paramz: {},
        pathParams: ["id"],
    },
}

export default PointLimitPolicyAPI
